{
  "acceptInvitation": "Einladung annehmen",
  "email": "E-Mail",
  "forgotPassword": "Passwort vergessen?",
  "haveInvitation": "Haben Sie eine Einladung?",
  "noAccount": "Noch kein Konto?",
  "password": "Passwort",
  "pleaseWait": "Bitte warten…",
  "register": "Konto anlegen",
  "sessionEnded": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "setupOpenAction": "Erste Administration einrichten",
  "setupOpenMessage": "Wer DMW installiert hat, richtet die erste Administration mit dem Einrichtungs-Token aus der Serverkonfiguration ein.",
  "setupOpenTitle": "Diese Installation hat noch keine Administration",
  "submit": "Anmelden",
  "title": "Anmelden"
}
